'use strict';

Object.defineProperty(exports, Symbol.toStringTag, { value: 'Module' });

const React = require('react');

const useCopyToClipboard = (value) => {
  const [didCopy, setDidCopy] = React.useState(false);
  const handleCopyText = React.useCallback(() => {
    navigator.clipboard.writeText(value).then(() => {
      setDidCopy(true);
    });
  }, [value]);
  React.useEffect(() => {
    if (didCopy === true) {
      const setDidCopyTimeout = setTimeout(() => {
        setDidCopy(false);
      }, 3e3);
      return () => clearTimeout(setDidCopyTimeout);
    }
    return () => void 0;
  }, [didCopy]);
  return [didCopy, handleCopyText];
};

exports.useCopyToClipboard = useCopyToClipboard;
//# sourceMappingURL=useCopyToClipboard.cjs.js.map
